export const tabTaxGroups = {
	addNewTaxGroup: "Adicionar novo grupo",
	emptyTaxGroupsMessage: "Não existem grupos fiscais de produto a serem mostrados",
	infosTaxGroup: {
		aliquot: "Aliquota",
		cfop: "CFOP",
		tax: "Taxa",
		type: "Tipo",
	},
	searchPlaceholder: "Pesquisar grupos fiscais de produto",
	typeLabel: {
		invoice: "Fatura",
		service: "Serviço",
		serviceNational: "Serviço nacional",
		vat: "IVA (Portugal)",
		vatFactura: "IVA (México)",
		vatSpain: "IVA (Espanha)",
	},
};
